"use strict";
// (C) 2007-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLocale = void 0;
/**
 * Default value for {@link ILocale}.
 *
 * @public
 */
exports.DefaultLocale = "en-US";
//# sourceMappingURL=Locale.js.map